export type ScopeAnchor = { startLine: number; startColumn: number };

export function scopeAnchorKey(anchor: ScopeAnchor | null | undefined): string | null {
  if (anchor == null) return null;
  return `${anchor.startLine}:${anchor.startColumn}`;
}

export function serializeScopeChain(chain: readonly ScopeAnchor[]): string | null {
  if (chain.length === 0) return null;
  return chain.map((anchor) => `${anchor.startLine}:${anchor.startColumn}`).join(',');
}

export function parseScopeChain(raw: string | null | undefined): ScopeAnchor[] {
  if (!raw) return [];
  const out: ScopeAnchor[] = [];
  for (const part of raw.split(',')) {
    if (!part) continue;
    const colon = part.indexOf(':');
    if (colon < 0) continue;
    const startLine = Number(part.slice(0, colon));
    const startColumn = Number(part.slice(colon + 1));
    if (!Number.isFinite(startLine) || !Number.isFinite(startColumn)) continue;
    out.push({ startLine, startColumn });
  }
  return out;
}

export function scopeChainKeys(chain: readonly ScopeAnchor[]): string[] {
  return chain.map((anchor) => scopeAnchorKey(anchor)!).filter(Boolean);
}

export function anchorInScopeChain(
  line: number | null | undefined,
  column: number | null | undefined,
  chain: readonly ScopeAnchor[],
): boolean {
  if (line == null || column == null) return chain.length === 0;
  return chain.some((anchor) => anchor.startLine === line && anchor.startColumn === column);
}
